<template>
  <b-modal
    centered
    id="split-file-modal"
    ref="splitFileRef"
    size="sm"
    hide-backdrop
    no-close-on-backdrop
    @cancel="fullname = null"
    ok-title="Split File"
    @ok="splitFile"
    @hidden="$emit('hidden')"
    :ok-disabled="isError"
    cancel-variant="light"
  >
    <template #modal-title>
      <span class="fw-500 text-grey-500">Split File - </span
      ><span class="text-primary fw-500">{{ data.filename }}</span>
    </template>

    <div class="form-group text-grey-800">
      <label for="fullname">Mode</label>
      <div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="splitType"
            value="file"
            id="splitType1"
            v-model="splitType"
          />
          <label class="form-check-label" for="splitType1"> File </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="splitType"
            value="record"
            id="splitType2"
            v-model="splitType"
          />
          <label class="form-check-label" for="splitType2"> Records </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="splitType"
            value="category"
            id="splitType3"
            v-model="splitType"
          />
          <label class="form-check-label" for="splitType3"> Category </label>
        </div>
      </div>
    </div>

    <div class="form-group text-grey-800" v-if="splitType === 'category'">
      <label for="brand-keyword">Brand Keyword</label>
      <select v-model="criteria.brandCategories" class="form-control">
        <option :value="null" disabled selected>Select Brand Category</option>
        <option :value="cat" v-for="cat in brandCategories" :key="cat">
          {{ cat }}
        </option>
      </select>
    </div>

    <div v-else>
      <div class="form-group text-grey-800">
        <label for="splitType">Number of {{ splitType }}</label>
        <div class="input-group">
          <input
            type="number"
            min="0"
            v-model="count"
            class="form-control"
            :class="{ 'border-danger': isError }"
          />
        </div>
        <div class="text-danger" v-if="isError">{{ errorMessage }}</div>
      </div>

      <div class="text-warning">
        Please re-checked information before split file
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import serviceRoutes from '../../service-routes'

export default {
  emits: ['success'],
  components: {
    'b-modal': BModal
  },
  directives: {
    'b-modal': VBModal
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      splitType: 'file',
      count: 2,

      brandCategories: [],
      criteria: {
        date: null,
        brandCategories: null
      }
    }
  },
  mounted() {
    this.loadCategories()
  },
  watch: {
    splitType() {
      if (this.splitType === 'file') {
        this.count = 2
      } else if (this.splitType === 'record') {
        this.count = null
      }
    }
  },
  computed: {
    isError() {
      return this.errorMessage.length > 0
    },
    errorMessage() {
      if (this.splitType === 'category') return ''
      let errorMsg = ''
      const newCount = this.data.total - this.data.progress
      if (this.count <= 0) {
        if (this.splitType === 'file') {
          errorMsg = 'Number of file must be greater than 1'
        } else {
          errorMsg = 'Number of record must not be 0'
        }
      } else {
        if (this.count >= newCount) {
          errorMsg = `Number of record must be less than ${newCount}`
        } else if (this.splitType === 'file') {
          if (this.count <= 1) {
            errorMsg = 'Number of file must be greater than 1'
          }
        }
      }
      return errorMsg
    }
  },
  methods: {
    async splitFile(e) {
      if (this.splitType === 'category') {
        this.splitCategory(e)
      } else {
        this.splitRecord(e)
      }
    },
    async splitRecord(e) {
      try {
        if (this.errorMessage.length === 0) {
          let perFile = this.count
          if (perFile > 0) {
            await serviceRoutes.splitRecordChunk(
              this.data._id,
              perFile,
              this.splitType
            )
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: 'File was splitted successfully.',
              showConfirmButton: false,
              timer: 0
            })

            this.$emit('success', true)
          }
        } else {
          e.preventDefault()
        }
      } catch (err) {
        const text = err.response.data ? err.response.data.message : undefined
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'File was splitted error.',
          text,
          showConfirmButton: false,
          timer: 0
        })
        e.preventDefault()
      }
    },
    loadCategories() {
      serviceRoutes.getDOMCategoryByAccount('kbank').then((res) => {
        this.brandCategories = res.data.data
      })
    },
    async splitCategory(e) {
      if (this.criteria.brandCategories.length > 0) {
        const brands = [this.criteria.brandCategories]
        const res = await serviceRoutes
          .splitRecordChunkByCategory(this.data._id, brands)
          .catch()
        if (res) {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'File was splitted category successfully.',
            showConfirmButton: false,
            timer: 0
          })
          this.$emit('success', true)
        }
      }
    }
  }
}
</script>
